export const emailIsEditedEnum = {
    1: 'edited',
    0: 'unedited',
};